<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.qualitySamplePlan.edit')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{path:'/prd/qualitySamplePlan', query:{id: qualitySamplePlan.id}}">
              <span>{{$t('tlt.qualitySamplePlan.new')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualitySamplePlan/edit">
              <span>{{$t('tlt.qualitySamplePlan.edit')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="BackToList()"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
          <button class="btn btn-primary" type="button" v-on:click="Save('qualitySamplePlan')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>

    <section class="app-content">
      <form>
        <div class="card my-1">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySamplePlan.sampleName')}}:
                </label>
                <input
                  name="sampleName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('sampleName') }"
                  v-model="sampleName"
                  type="text"
                />
                <span
                  v-show="errors.has('sampleName')"
                  class="lbl-obg"
                >{{ errors.first('sampleName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySamplePlan.sampleUser')}}:
                </label>
                <input
                  name="samplePerson"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('samplePerson') }"
                  v-model="samplePerson"
                  type="text"
                />
                <span
                  v-show="errors.has('samplePerson')"
                  class="lbl-obg"
                >{{ errors.first('samplePerson') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.qualitySamplePlan.furnaceName')}}:
                </label>
                <select
                  id="furnaceName"
                  name="furnaceName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('furnaceName') }"
                  v-model="furnaceName"
                  type="text"
                >
                  <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                  <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                  <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                  <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                  <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                  <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                </select>
                <span
                  v-show="errors.has('furnaceName')"
                  class="lbl-obg"
                >{{ errors.first('furnaceName') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { fields } from "@/model/prd/qualityMgt/pelletizing/QualitySamplePlan";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualitySamplePlan/getField",
  mutationType: "qualitySamplePlan/updateField"
});

export default {
  name: "qualitySamplePlanEdit",
  data() {
    return {};
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.qualitySamplePlan.rows,

      entity: state => state.qualitySamplePlan.entity,

      qualityPlanStatus: state => state.qualitySamplePlan.qualityPlanStatus,

      qualitySamplePlan: state => state.qualitySamplePlan
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"]),
        ...mapActions("qualitySamplePlan", ["BackToList","Save"]),

  }
};
</script>
